export default __webpack_public_path__ + "static/media/36.17780254.jpg";